<template>
  <div class="column content-box settings--content">
    <label class="step-title">{{
      $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.TITLE')
    }}</label>
    <div v-for="(item, index) in macros" :key="index" class="label-entry">
      <accordion-item
        :title="itemTitle(item)"
        :is-open="openAccordions[index]"
        @click="toggleAccordion(index)"
      >
        <label>{{
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.LABEL_MACRO')
        }}</label>
        <multiselect
          v-model="item.selectedMacro"
          track-by="id"
          label="name"
          :placeholder="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.SELECT_MACRO')
          "
          :multiple="false"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          :deselect-label="
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.DESELECT_MACRO')
          "
          :close-on-select="true"
          :options="getAvailableMacros(index)"
          :allow-empty="true"
        >
          <template v-slot:noResult>
            {{
              $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.NOT_MACROS_FOUND')
            }}
          </template>
        </multiselect>
        <label>
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.LABEL_INSTRUCTION')
          }}
          <textarea
            v-model.trim="item.instructions"
            class="textlong"
            :placeholder="
              $t(
                'INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.PLACEHOLDER_INSTRUCTION'
              )
            "
          />
        </label>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          size="small"
          type="button"
          @click="removeItem(index)"
        >
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.BUTTON_REMOVE_TEXT')
          }}
        </woot-button>
      </accordion-item>
    </div>
    <woot-button
      v-if="
        macros.length < macrosList.length &&
          getAvailableMacros(macros.length).length > 0
      "
      type="button"
      class="button--add-domain"
      icon="add"
      color-scheme="success"
      variant="smooth"
      size="small"
      @click="addItem"
    >
      <span>{{
        $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.BUTTON_ADD_TEXT')
      }}</span>
    </woot-button>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import assistentTabMixin from '../../mixins/assistentTabMixin';
import AccordionItem from '../../../profile/components/AccordionItem.vue';

const safeParse = val => {
  if (!val) return [];
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (e) {
    return [];
  }
};

export default {
  components: { AccordionItem },
  mixins: [assistentTabMixin],
  data() {
    return {
      macros: [],
      openAccordions: [],
    };
  },
  computed: {
    ...mapGetters({
      macrosList: 'macros/getMacros',
    }),
  },
  async created() {
    await this.$store.dispatch('macros/get');
    this.hydrate();
  },
  methods: {
    itemTitle(item) {
      if (item.selectedMacro) {
        return `${this.$t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.ITEM_PREFIX'
        )} ${item.selectedMacro.name}`;
      }
      return this.$t(
        'INTEGRATION_SETTINGS.ASSISTENT.FORM.MACROS.NEW_ITEM_TITLE'
      );
    },
    hydrate() {
      const dbMacros = safeParse(this.assistent.macros);
      this.macros = dbMacros.map(dbItem => {
        const fullMacro = this.macrosList.find(
          m => String(m.id) === String(dbItem.macro_id)
        );
        return {
          selectedMacro: fullMacro || {
            id: dbItem.macro_id,
            name: `Macro ID: ${dbItem.macro_id}`,
          },
          instructions: dbItem.instructions || '',
        };
      });
      this.openAccordions = this.macros.map(() => false);
    },
    getAvailableMacros(currentIndex) {
      const selectedInOtherRows = this.macros
        .filter((item, index) => index !== currentIndex && item.selectedMacro)
        .map(item => item.selectedMacro.id);

      return this.macrosList.filter(
        macro => !selectedInOtherRows.includes(macro.id)
      );
    },
    toggleAccordion(index) {
      this.$set(this.openAccordions, index, !this.openAccordions[index]);
    },
    addItem() {
      this.macros.push({ selectedMacro: null, instructions: '' });
      this.openAccordions = this.openAccordions.map(() => false);
      this.openAccordions.push(true);
    },
    removeItem(index) {
      this.macros.splice(index, 1);
      this.openAccordions.splice(index, 1);
    },
    async onSubmit() {
      const mappedMacros = this.macros
        .filter(item => item.selectedMacro)
        .map(item => ({
          macro_id: item.selectedMacro.id,
          instructions: item.instructions || '',
        }));

      await this.saveAssistent({ macros: JSON.stringify(mappedMacros) });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
